import { render, staticRenderFns } from "./TransferSearchResult.vue?vue&type=template&id=2340f79c&scoped=true"
import script from "./TransferSearchResult.vue?vue&type=script&lang=js"
export * from "./TransferSearchResult.vue?vue&type=script&lang=js"
import style0 from "./TransferSearchResult.vue?vue&type=style&index=0&id=2340f79c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2340f79c",
  null
  
)

export default component.exports